/* ORDER PROTECTED — KHÁCH TỰ TICK. Không bao giờ tự thêm.
 *
 * OPT-IN, chốt với chủ store 08/09. Trước đó bản này tự tick sẵn; đổi vì ô tick
 * sẵn cho một khoản CÓ THU TIỀN bị EU cấm (Chỉ thị Quyền người tiêu dùng, Điều
 * 22) và UK cấm (Consumer Contracts Regulations) — cả hai đòi khách đồng ý chủ
 * động, hộp tick sẵn không tính là đồng ý. Store bán toàn cầu.
 *
 * HỆ QUẢ LỚN NHẤT VỀ MÃ: không còn cần nhớ "khách đã từ chối". Cờ
 * `Order Protection: Declined` ngày trước sinh ra CHỈ để chặn vòng "khách bỏ
 * tick -> JS thêm lại ngay". Không còn tự thêm thì không còn vòng đó, nên cờ
 * cũng không còn lý do tồn tại — đã gỡ cả đường ghi lẫn đường đọc.
 *
 * Còn lại đúng một chỗ đụng tới cờ: giỏ nào ĐANG mang cờ từ thời tự-tick thì
 * XOÁ nó đi ngay lần khách tick. Không xoá thì đơn hiện lên admin vừa có dòng
 * bảo vệ vừa ghi "Declined" — chủ store đọc đơn thật sẽ rối. Chỉ chạy khi
 * `data-tuchoi` bật, nên giỏ mới không phải trả thêm request nào; cờ tự hết dần
 * theo vòng đời cookie giỏ.
 *
 * MỌI SỰ THẬT ĐẾN TỪ SERVER. Snippet in ra `data-base` (subtotal đã TRỪ chính
 * dòng phí), `data-vid` (variant đang trong giỏ) và `data-want` (variant đúng
 * bậc). File này không tự tính lại giỏ — chỉ so rồi gọi API khi lệch. Nhờ vậy
 * sau mỗi lần drawer vẽ lại, trạng thái tự đúng.
 *
 * VÌ SAO BASE PHẢI TRỪ CHÍNH DÒNG PHÍ. Dòng bảo vệ nằm trong subtotal. Lấy
 * nguyên subtotal để chọn bậc thì giỏ sát mốc tự đẩy mình lên bậc trên, bậc trên
 * lại đẩy tiếp — nhảy vô hạn. Liquid đã trừ sẵn; ghi ở đây để đừng ai "sửa lại
 * cho gọn" bằng cart.total_price.
 *
 * ĐỔI BẬC = XOÁ RỒI THÊM. Shopify không cho đổi variant của một dòng đang có;
 * `/cart/change.js` chỉ đổi được số lượng.
 */
(function () {
  'use strict';

  var GOC = '[data-lb-op]';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var dangChay = false;

  /* Vẽ lại drawer bằng đúng cơ chế của theme: xin Shopify render sẵn hai section
     rồi giao cho `renderContents`. Cùng đường mà nút bundle đang dùng — xem ghi
     chú dài trong legendbrix-demo-product.js. */
  function veLai(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
      var el = document.querySelector('cart-drawer.drawer');
      if (el) el.classList.remove('is-empty');
      return true;
    }
    return false;
  }

  function goi(url, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function xong(data) {
    dangChay = false;
    /* TRANG /cart PHẢI TẢI LẠI. Nó có bảng giỏ riêng (`#main-cart-items`) mà hai
       section xin về không đụng tới, nên vẽ lại drawer thôi là bảng và tổng tiền
       đứng im trong khi giỏ đã đổi.

       Bản trước dò bằng "trang này có drawer hay không" và cho rằng /cart thì
       không có — SAI: drawer nằm trong layout nên trang nào cũng có, kể cả
       /cart. Hậu quả: `veLai` luôn trả true, không bao giờ tải lại, bảng giỏ ở
       /cart hiển thị sai cho tới khi khách tự F5. Đo được 27/08. */
    if (!document.getElementById('main-cart-items') && veLai(data)) { danhGia(); return; }
    window.location.reload();
  }

  function hong(g) {
    dangChay = false;
    // Trả ô tick về đúng trạng thái thật của giỏ. Không làm thì khách thấy ô đã
    // tick mà tiền không đổi — tưởng đã mua trong khi chưa.
    if (g) {
      var cb = g.querySelector('.lb-op__cb');
      if (cb) cb.checked = g.getAttribute('data-vid') !== '0';
    }
  }

  function them(id) { return goi('/cart/add.js', { items: [{ id: id, quantity: 1 }] }); }
  /* Chỉ còn dùng để XOÁ cờ cũ (`co` luôn false). Chuỗi rỗng là cách Shopify xoá
     một thuộc tính giỏ; không có lệnh xoá riêng. */
  function ghiTuChoi(co) {
    return goi('/cart/update.js', { attributes: { 'Order Protection': co ? 'Declined' : '' } });
  }
  function bo(key) { return goi('/cart/change.js', { id: key, quantity: 0 }); }

  function doc(g) {
    return {
      base: parseInt(g.getAttribute('data-base'), 10) || 0,
      vid: parseInt(g.getAttribute('data-vid'), 10) || 0,
      want: parseInt(g.getAttribute('data-want'), 10) || 0,
      key: g.getAttribute('data-key') || '',
      tuchoi: g.getAttribute('data-tuchoi') === '1'
    };
  }

  /* Chạy sau mỗi lần giỏ đổi. Chỉ làm hai việc, và cả hai đều chỉ động tới khoản
     bảo vệ ĐÃ CÓ SẴN trong giỏ — KHÔNG BAO GIỜ TỰ THÊM MỚI:
       1. Giỏ không còn hàng nào khác -> gỡ khoản bảo vệ ra. Một giỏ chứa độc một
          khoản bảo vệ là thứ không ai cố ý tạo.
       2. Khách đổi số lượng làm giỏ sang bậc khác -> đổi variant cho khớp.

     Chưa có dòng bảo vệ thì hàm này KHÔNG làm gì. Đó chính là opt-in: đường duy
     nhất để khoản này vào giỏ là khách tự tick, xử lý ở handler `change` bên
     dưới. Đừng thêm nhánh "tự thêm" vào đây. */
  function danhGia() {
    if (dangChay) return;
    var g = document.querySelector(GOC);
    if (!g) return;
    var s = doc(g);
    if (!s.vid) return;

    if (s.base <= 0) {
      dangChay = true;
      bo(s.key).then(xong).catch(function () { hong(g); });
    } else if (s.vid !== s.want) {
      dangChay = true;
      bo(s.key).then(function () { return them(s.want); })
               .then(xong).catch(function () { hong(g); });
    }
  }

  /* Gắn ở document chứ không ở phần tử: drawer bị thay HTML sau mỗi lần cập nhật
     giỏ, listener gắn trực tiếp sẽ mất theo. */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest ? e.target.closest('.lb-op__cb') : null;
    if (!cb) return;
    var g = cb.closest(GOC);
    if (!g || dangChay) return;
    var s = doc(g);
    dangChay = true;
    if (cb.checked) {
      if (s.vid) { dangChay = false; return; }
      /* Giỏ cũ còn mang cờ "Declined" từ thời tự-tick thì dọn trước, để đơn
         không vừa có dòng bảo vệ vừa ghi là đã từ chối. Giỏ mới không có cờ nên
         đi thẳng, không tốn thêm request. */
      var truoc = s.tuchoi ? ghiTuChoi(false) : Promise.resolve();
      truoc.then(function () { return them(s.want); })
           .then(xong).catch(function () { hong(g); });
    } else {
      if (!s.vid) { dangChay = false; return; }
      // Gỡ là xong. Không ghi cờ gì cả — không còn ai tự thêm lại.
      bo(s.key).then(xong).catch(function () { hong(g); });
    }
  });

  /* THÙNG RÁC Ở TRANG /cart: ĐỂ SHRINE LO, không chặn.

     Bản tự-tick từng phải bắt cú bấm này ở pha capture rồi tự gỡ, vì
     `/cart/change` không đụng tới thuộc tính giỏ nên gỡ xong là `danhGia()`
     thêm lại ngay — khách bấm mãi không gỡ được. Hết tự thêm thì hết lỗi đó, và
     dòng bảo vệ gỡ đi như mọi dòng hàng khác. Đừng dựng lại handler đó. */

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.lb-op__i') : null;
    if (!b) return;
    var mo = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', mo ? 'true' : 'false');
    var hop = document.getElementById(b.getAttribute('aria-controls'));
    if (hop) hop.hidden = !mo;
  });

  /* Drawer vẽ lại = data-* mới. Theo dõi thay đổi con của nó rồi đánh giá lại,
     gộp nhiều thay đổi liên tiếp vào một lần để khỏi bắn hàng loạt request. */
  var hen = null;
  function theoDoi() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    new MutationObserver(function () {
      clearTimeout(hen);
      hen = setTimeout(danhGia, 150);
    }).observe(d, { childList: true, subtree: true });
  }

  function batDau() { theoDoi(); danhGia(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', batDau);
  } else {
    batDau();
  }
})();
